import authActions from '../../actions/auth/auth';

const LOCAL_STORAGE_KEYS = {
  AUTH_TOKEN: 'AUTH_TOKEN',
  ROLES: 'ROLES',
  DEVICE_TOKEN: 'DEVICE_TOKEN',
};

const initialState = {
  token: localStorage.getItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN),
  roles: localStorage.getItem(LOCAL_STORAGE_KEYS.ROLES)
    ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.ROLES)) : [],
  deviceToken: localStorage.getItem(LOCAL_STORAGE_KEYS.DEVICE_TOKEN),
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case authActions.LOGIN_SUCCESS: {
      const { token, roles } = action;

      localStorage.setItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN, token);
      localStorage.setItem(LOCAL_STORAGE_KEYS.ROLES, JSON.stringify(roles));

      return {
        ...state,
        token,
        roles,
      };
    }
    case authActions.LOG_OUT: {
      delete localStorage[LOCAL_STORAGE_KEYS.AUTH_TOKEN];
      delete localStorage[LOCAL_STORAGE_KEYS.ROLES];

      return {
        ...state,
        token: null,
        roles: [],
      };
    }
    case authActions.SET_DEVICE_TOKEN: {
      const { deviceToken } = action;

      localStorage.setItem(LOCAL_STORAGE_KEYS.DEVICE_TOKEN, deviceToken);
      return {
        ...state,
        deviceToken,
      };
    }

    default:
      return state;
  }
};

export default authReducer;
